import React from 'react';
import { LogIn } from 'components/user/logIn';

export const SignInPage: React.FC = () => <LogIn />;
